var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"课程列表","name":"course"}},[_c('CourseList')],1),_c('TabPane',{attrs:{"label":"课程数据定义","name":"course-data"}},[_c('CourseDataTypeList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }